import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormRequired', null, { withChildren: true });
